<script lang="ts">
	import { _ } from '@repo/i18n'
	import { ToastType } from '@repo/ui'
	import { toasts } from '@repo/ui'
	import { type Snippet, createEventDispatcher } from 'svelte'

	interface Props {
		text: string
		children?: Snippet<[any]>
	}

	let { text, children }: Props = $props()

	const dispatch = createEventDispatcher()

	function onCopy() {
		navigator.clipboard.writeText(text).then(handleSuccessfullyCopied, handleFailedCopy)
	}

	let copied = $state(false)

	function handleSuccessfullyCopied() {
		dispatch('copy', text)
		copied = true

		setTimeout(() => (copied = false), 5 * 1000)
	}

	function handleFailedCopy() {
		dispatch('fail')
		toasts.add({
			title: $_('share.error'),
			type: ToastType.error,
		})
	}
</script>

{@render children?.({ copied, onCopy })}
